<template>
  <qtm-btn class="text-interactive" tertiary @click="$emit('update:model-value', true)">
    <div class="d-flex align-center">
      <v-badge
        color="primary"
        dot
        height="8"
        location="top start"
        :model-value="unreadNotifications"
        offset-x="0"
        offset-y="2"
        width="8"
      >
        <v-icon class="mr-1" icon="mso:notifications" size="24" />
      </v-badge>
      Notifications
    </div>
  </qtm-btn>
</template>

<script setup lang="ts">
import { unreadNotifications } from './notifications-store'

defineEmits(['update:model-value'])
</script>
